import axios from 'axios'

interface UploadResponse {
  url: string
}

export default function useConnectUpload() {
  async function uploadToConnect(formData: FormData): Promise<UploadResponse> {
    try {
      const res = await axios.post<UploadResponse>(`https://connect.pitcher.com/api/NG/uploadAsset.php`, formData, {
        timeout: 0,
      })
      return res.data
    } catch (error) {
      console.error('Error uploading to Connect:', error)
      throw error
    }
  }

  return {
    uploadToConnect,
  }
}
